export default __webpack_public_path__ + "assets/icon-receipt-with-beta.a7a0f54e.png";